import moment from "moment";
import React from "react";
import BrandIcon from "../../../components/BrandIcon";
import Panel from "../../../components/panels/panel";
import { routes } from "utilities/routing/generatedRoutes";

const PaymentMethodProblems = () => {
  const [paymentProblems, setPaymentProblems] = React.useState<server.dto.ClientWithPaymentMethodProblem[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  React.useEffect(() => {
    window.CoreApi.Client.ListClientsWithPaymentMethodProblem()
      .then(res => {
        setIsLoading(false);
        if (res.data.hasErrors) {
          return;
        }
        setPaymentProblems(res.data.data);
      });
  }, []);

  return <Panel
    title="Clients with declined cards"
    isLoading={isLoading}
    panelClassName="s1_dashboard-panel"
    hasData={paymentProblems.length > 0}
  >
    <div className="list-with-gaps line-layout">
      <div className="list-with-gaps-body">
        {paymentProblems.map((problem, idx) => (
          <div key={idx}>
            <div>
              <BrandIcon name={problem.client.name} iconUrl={problem.client.iconUrl} size={50} />
            </div>
            <div className="grow1">
              <div><a href={routes.client_DetailAdminOne(problem.client.clientId).absolute}>{problem.client.name}</a></div>
              <div className="text-sublabel">client {problem.client.clientId}</div>
            </div>
            <div>
              {moment.utc(problem.sinceUtc).fromNow()}
            </div>
          </div>
        ))}
      </div>
    </div>
  </Panel >;
};

export default PaymentMethodProblems;